<!-- 题库管理 -->
<template>
  <div class="examBankManagement">
    <div class="nav-bar">
      <div class="nav-left"></div>
      <div class="nav-right">
        <el-button type="primary" @click="handleBtn('创建题库')">创建题库</el-button>
        <el-button type="primary" @click="handleBtn('创建题目')">创建题目</el-button>
      </div>
    </div>
    <el-table v-loading="tableLoading" :data="tableData" style="width: 100%; font-size: 14px">
      <el-table-column prop="bank_name" label="题库名称">
        <!-- 题库编辑 -->
        <template slot-scope="scope">
          <el-popover
            :ref="`popover-${scope.$index + scope.column.id}`"
            placement="bottom-start"
            title="修改"
            width="400"
            trigger="click"
            popper-class="edit_box"
          >
            <div class="edit_content">
              <el-input
                v-model.trim="editInput"
                placeholder="请输入"
                clearable
                maxlength="16"
                show-word-limit
                class="input"
                @keyup.native.enter="handleEdit('确定', scope, 'bank_name')"
              ></el-input>
              <div class="btn">
                <el-button @click="handleEdit('取消', scope)">取消</el-button>
                <el-button type="primary" @click="handleEdit('确定', scope, 'bank_name')">
                  确定
                </el-button>
              </div>
            </div>
            <div slot="reference">
              <div class="edit_able" @click="handleEdit('编辑', scope, 'bank_name')">
                {{ scope.row.bank_name || '-' }}
              </div>
            </div>
          </el-popover>
        </template>
      </el-table-column>
      <el-table-column prop="total_num" label="试题数"></el-table-column>
      <el-table-column prop="single_num" label="单选"></el-table-column>
      <el-table-column prop="multiple_num" label="多选"></el-table-column>
      <el-table-column prop="bank_remark" label="备注">
        <!-- 题库编辑 -->
        <template slot-scope="scope">
          <el-popover
            :ref="`popover-${scope.$index + scope.column.id}`"
            placement="bottom-start"
            title="修改"
            width="400"
            trigger="click"
            popper-class="edit_box"
          >
            <div class="edit_content">
              <el-input
                v-model.trim="editInput"
                placeholder="请输入"
                clearable
                maxlength="32"
                show-word-limit
                class="input"
                @keyup.native.enter="handleEdit('确定', scope, 'bank_remark')"
              ></el-input>
              <div class="btn">
                <el-button @click="handleEdit('取消', scope)">取消</el-button>
                <el-button type="primary" @click="handleEdit('确定', scope, 'bank_remark')">
                  确定
                </el-button>
              </div>
            </div>
            <div slot="reference">
              <div class="edit_able" @click="handleEdit('编辑', scope, 'bank_remark')">
                {{ scope.row.bank_remark || '-' }}
              </div>
            </div>
          </el-popover>
        </template>
      </el-table-column>
      <el-table-column prop="update_user" label="最后更新人"></el-table-column>
      <el-table-column prop="update_time" label="最后更新时间">
        <template slot-scope="scope">
          {{ scope.row.update_time | filterTime }}
        </template>
      </el-table-column>
      <el-table-column label="操作" width="150" fixed="right">
        <template slot-scope="scope">
          <el-button
            @click="tableActionFun({ action: '进入题目列表', row: scope.row })"
            type="text"
            size="small"
            style="font-size: 14px"
          >
            进入题目列表
          </el-button>
          <el-button
            @click="
              () => {
                delDialogVisible = true;
                rowTemp = scope.row;
              }
            "
            type="text"
            size="small"
            style="font-size: 14px"
          >
            删除
          </el-button>
        </template>
      </el-table-column>
      <div slot="empty"><NoData></NoData></div>
    </el-table>
    <el-pagination
      class="pagination"
      style="background-color: #ffffff"
      :current-page="tableCurPage"
      :page-size="tablePageSize"
      :total="tableTotal"
      @current-change="currentChangeFun"
      layout="total, sizes, prev, pager, next, jumper"
      :page-sizes="g_pageSizesConfig"
      @size-change="handleSizeChange"
    />
    <!-- 创建题库 -->
    <ConfigDialog
      config-name="addExanBank"
      :dialog-visible.sync="configDialogVisible"
      @dialogEmit="dialogEmit"
    ></ConfigDialog>
    <!-- 删除 -->
    <el-dialog title="提示" :visible.sync="delDialogVisible" width="30%" center>
      <div style="text-align: center; font-size: 20px">确定删除该题库吗?</div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="delDialogVisible = false">取 消</el-button>
        <el-button
          type="primary"
          @click="
            () => {
              delDialogVisible = false;
              tableActionFun({ action: '删除', row: rowTemp });
            }
          "
        >
          确 定
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mixinTable } from './mixin/table.js';
import { GetQuestionBankList, UpdateBank, RemoveQuestionBank } from '@/api/examBankManagement';
export default {
  name: 'ExamBankManagement',
  components: {},
  mixins: [mixinTable],
  props: {},
  data() {
    return {
      editInput: '', // 编辑输入
    };
  },
  // 生命周期 - 创建完成（访问当前this实例）
  created() {},
  // 生命周期 - 挂载完成（访问DOM元素）
  mounted() {},
  methods: {
    // 查询表格列表
    async getTaleData() {
      this.tableLoading = true;
      try {
        const res = await GetQuestionBankList({
          page_index: this.tableCurPage, // 分页码
          page_size: this.tablePageSize, // 分页码
        });
        this.tableTotal = res.total || 0;
        this.tableData = res.bank_list || [];
      } catch (error) {
        this.$message.error(error.message);
        this.tableLoading = false;
      }
      this.tableLoading = false;
    },
    /** 表格操作
     * @description: 表格操作事件
     * @param {string} action 操作名称
     * @param {object} row 操作行数据
     * @return {*} void
     */
    async tableActionFun({ action, row }) {
      switch (action) {
        case '进入题目列表':
          this.g_tourl(`/saas/examBankManagement/detailExamBank.html?bank_id=${row.bank_id}`);
          break;
        case '删除':
          // 删除=>重新请求数据
          this.tableLoading = true;
          try {
            await RemoveQuestionBank({
              bank_id: row.bank_id,
            });
            this.$message.success('删除成功');
            this.getTaleData();
          } catch (error) {
            this.$message.error(error.message);
          }
          this.tableLoading = false;
          break;
        default:
          break;
      }
    },
    // 题库编辑
    async handleEdit(htmlText, scope, key) {
      switch (htmlText) {
        case '编辑':
          this.editInput = scope.row[key];
          break;
        case '确定':
          if (!this.editInput) {
            this.$message.warning('请输入内容');
            return;
          }
          // 更新=>重新请求数据
          this.tableLoading = true;
          try {
            await UpdateBank({
              bank_id: scope.row.bank_id,
              bank_name: scope.row.bank_name,
              bank_remark: scope.row.bank_remark,
              [key]: this.editInput, // 自然覆盖以上修改的某一字段
            });
            this.$message.success('修改成功');
            document.body.click();
            this.getTaleData();
          } catch (error) {
            this.$message.error(error.message);
          }
          this.tableLoading = false;
          break;
        case '取消':
          document.body.click();
          //   this.$refs[`popover-${scope.$index + scope.column.id}`].doClose();
          break;
        default:
          break;
      }
    },
    // 操作按钮
    handleBtn(e) {
      switch (e) {
        case '创建题库':
          this.configDialogVisible = true;
          break;
        case '创建题目':
          this.g_tourl(`/saas/examBankManagement/addExam.html`);
          break;
        default:
          break;
      }
    },
    // 弹窗确认回调
    dialogEmit(e) {
      if (e) {
        this.reloadTable(true);
      }
    },
  },
};
</script>

<style lang="scss">
//分页
.pagination {
  margin-top: 12px;
  text-align: right;

  & ::v-deep .el-pager li.number {
    color: #606266;
  }

  & ::v-deep .el-pager li.active {
    color: #2f96ff !important;
  }

  & ::v-deep .el-input__inner {
    width: 46px;
    border-radius: 3px;
    height: 24px;
  }
}

// 编辑弹窗
.edit_box {
  .edit_content {
    .input {
      padding: 15px 0;
    }
    .btn {
      text-align: right;
      margin: 0;
    }
  }
}
</style>

<style lang="scss" scoped>
.examBankManagement {
  // 条件栏
  .nav-bar {
    padding-bottom: 20px;
    &::after {
      content: '';
      display: block;
      clear: both;
    }
    .nav-left {
      display: inline-block;
    }
    .nav-right {
      float: right;
    }
  }
  // 表格鼠标文字编辑悬浮
  .edit_able {
    position: relative;
    cursor: pointer;
    padding-right: 10px;
    &:hover {
      // text-decoration: underline;
      // color: #5fa4e8;
      &:after {
        position: absolute;
        //   content: '🖋🖊🖌🖍';
        content: '🖍';
        display: inline-block;
        font-size: 20px;
        padding-left: 5px;
        text-decoration: underline;
      }
    }
  }
}
</style>
